import apiClient from '../api/apiClient';
import { ChangePasswordRequest, ChangePasswordResponse } from '../../types/auth';

class ChangePasswordService {
  private static readonly API_TIMEOUT = 10000; // 10 seconds

  /**
   * Change user password after forced password change
   */
  static async changePassword(
    newPassword: string,
    sessionId: string
  ): Promise<ChangePasswordResponse> {
    try {
      const request: ChangePasswordRequest = {
        newPassword
      };

      const response = await apiClient.put(
        `/password/change?sessionId=${sessionId}`,
        request,
        {
          timeout: this.API_TIMEOUT,
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );

      // Check if response is successful (200 status)
      if (response.status === 200 && response.data.success) {
        return {
          success: true,
          message: response.data.message || null
        };
      }
      
      // For any non-200 or success=false, return technical error message
      return {
        success: false,
        message: 'Sorry, looks like we are having technical issues. Please give us time to fix the issue. Then, try again.'
      };
    } catch (error: any) {
      // For all HTTP errors (4xx, 5xx) or network errors
      console.error('Error changing password:', error);
      
      return {
        success: false,
        message: 'Sorry, looks like we are having technical issues. Please give us time to fix the issue. Then, try again.'
      };
    }
  }
}

export default ChangePasswordService;
